import Vue from "vue";

export async function accessMarketplace(data) {
  const response = await Vue.prototype.$http.post(
    `/marketplace_auth/connector/sessions`,
    data
  );

  return response.data;
}

export async function storeSession(data) {
  const response = await Vue.prototype.$http.post(`/marketplace/session`, data);

  return response.data;
}

export async function destroySession(id) {
  const response = await Vue.prototype.$http.delete(
    `/marketplace/session/${id}`
  );

  return response;
}

export async function generateReport(id) {
  const response = await Vue.prototype.$http.post(
    `/marketplace/session/${id}/generate-report`
  );

  return response;
}
